import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';
import CalendlyPopup from '../CalendlyPopup';
import { useCalendlyAndVideo } from '../../hooks/useCalendlyAndVideo';

const CadenceCTA = () => {
  const { isCalendlyOpen, openCalendly, closeCalendly } = useCalendlyAndVideo();

  return (
    <section className="py-20 px-6 bg-gray-900/50">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 text-white">
          Practice Once. <span className="text-cyan-400">Perform Everywhere.</span>
        </h2>
        
        <p className="text-lg text-gray-400 mb-4 max-w-3xl mx-auto">
          Traain Cadence ensures every team member practices to the same standard — regardless of location, tenure, or manager availability.
        </p>
        
        <p className="text-xl text-white font-semibold mb-12">
          Build confident, consistent performers with Traain Cadence.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            size="lg"
            onClick={openCalendly}
            className="h-14 bg-cyan-500 text-black hover:bg-cyan-400 rounded-lg px-8 text-lg font-semibold transition-all duration-200 hover:scale-105 hover:shadow-lg hover:shadow-cyan-500/50"
            data-testid="cadence-cta-demo-btn"
          >
            Schedule a Discovery Call
            <ArrowRight className="w-5 h-5 ml-2" />
          </Button>
        </div>
      </div>
      
      <CalendlyPopup isOpen={isCalendlyOpen} onClose={closeCalendly} />
    </section>
  );
};

export default CadenceCTA;
